import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const ClickToCopy = ({ text }) => {
  const [tooltipText, setTooltipText] = useState('Copy')

  const onCopy = () => {
    setTooltipText('Copied!')
    setTimeout(() => {
      setTooltipText('Copy')
    }, 2000);
  };

  return (
    <OverlayTrigger
      trigger={['hover']}
      placement="top"
      overlay={
        <Tooltip
          id="tooltipText"
          className='position-fixed'
        >
          {tooltipText}
        </Tooltip>
      }
    >
      <CopyToClipboard
        text={text}
        onCopy={onCopy}
      >
        <span className='cursor-pointer'>{text}</span>
      </CopyToClipboard>
    </OverlayTrigger>
  );
};

export default ClickToCopy;
